import { render } from "./sales-pos.vue?vue&type=template&id=22eda9f2"
import script from "./sales-pos.vue?vue&type=script&lang=js"
export * from "./sales-pos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__